import type { BlobLike } from "@pdfking/compatibility"
import type { AsyncSequence } from "@pdfking/tfunc"

import type { PageNumber } from "../units/Units"
import type { PDFReaderOptions } from "./PDFReaderOptions"

export type PDFMergeInput = {
  page_number: PageNumber
} & PDFReaderOptions

export type PDFMergeFunction = (
  pages: AsyncSequence<PDFMergeInput>
) => AsyncGenerator<BlobLike>
